export const BirthDateErrors = {
  required: 'Це поле обов’язкове',
};

export enum EEnterBirthDateFormFields {
  BIRTH_DATE = 'birthDate',
}
